export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';
export const ADD_USER_LOADING = 'ADD_USER_LOADING';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';

export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_LOADING = 'UPDATE_USER_LOADING';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const FETCH_USERS_LOADING = 'FETCH_USERS_LOADING';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';

export const FETCH_BY_ID_USER_FAILURE = 'FETCH_BY_ID_USER_FAILURE';
export const FETCH_BY_ID_USER_LOADING = 'FETCH_BY_ID_USER_LOADING';
export const FETCH_BY_ID_USER_SUCCESS = 'FETCH_BY_ID_USER_SUCCESS';

export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';
export const DELETE_USER_LOADING = 'DELETE_USER_LOADING';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const FETCH_BUILDING_USERS_FAILURE = 'FETCH_BUILDING_USERS_FAILURE';
export const FETCH_BUILDING_USERS_LOADING = 'FETCH_BUILDING_USERS_LOADING';
export const FETCH_BUILDING_USERS_SUCCESS = 'FETCH_BUILDING_USERS_SUCCESS';

export const FETCH_MANAGERS_LOADING = 'FETCH_MANAGERS_LOADING';
export const FETCH_MANAGERS_SUCCESS = 'FETCH_MANAGERS_SUCCESS';
export const FETCH_MANAGERS_FAILURE = 'FETCH_MANAGERS_FAILURE';
